import { Chart as ChartJS, ChartComponentLike } from 'chart.js'
import { ReactElement } from 'react'

const ChartProvider = ({
  listChart,
  children,
}: {
  listChart: ChartComponentLike
  children: ReactElement
}) => {
  ChartJS.register(listChart)
  return <>{children}</>
}

export default ChartProvider
